import configStore from "../stores/ConfigStore";

export const parseDate = (timestamp: number | string): string => {
  return new Date(timestamp).toLocaleDateString(
    `${configStore.currentLanguage}`,
    {
      year: "numeric",
      month: "long",
      day: "numeric",
    },
  );
};
